"use strict";
var protobuf = module.exports = require(7);

protobuf.build = "full";

// Parser
protobuf.tokenize         = require(24);
protobuf.parse            = require(16);
protobuf.common           = require(1);

// Configure parser
protobuf.Root._configure(protobuf.Type, protobuf.parse, protobuf.common);
